export default "__VITE_ASSET__4se$afFA__"